import { languageHelper } from "../../../../config/helperFunctions";
import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function Vendorreport() {
  const [columns] = useState([
    {
      header: languageHelper("SN"),
      accessorKey: "SN",
    },

    {
      header: languageHelper("Date"),
      accessorKey: "Date",
    },
    {
      header: languageHelper("Product Price"),
      accessorKey: "Product Price",
    },
    {
      header: languageHelper("Name"),
      accessorKey: "Name",
    },
    {
      header: languageHelper("Name Arabic"),
      accessorKey: "Name Arabic",
    },
    {
      header: languageHelper("sub total"),
      accessorKey: "sub total",
    },
    {
      header: languageHelper("Discount"),
      accessorKey: "Discount",
    },
    {
      header: languageHelper("Vat"),
      accessorKey: "Vat",
    },{
        header: languageHelper("Vendor name"),
        accessorKey: "Vendor name",
      },
    
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: languageHelper("Submit"),
    },
  ]);

  const [selectButton] = useState([
    {
      placeholder: "User",
    }, {
        placeholder: "Vendor Name",
      },
  ]);
  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper("Vendor report")}
        buttonDataa={buttonDataa}
        selectButton={selectButton}
      />
    </main>
  );
}

export default Vendorreport;
